import { useTranslation } from "react-i18next";
import UploadImages from "./upload-images";
import { PropertyReport } from "../../Models/PropertyReport";

const CoverPhoto: React.FunctionComponent<{ errors: any, property: PropertyReport, OnChangeCover: any }> = (props) => {


    const UploadImagesHandler = (images: any) => {
        props.OnChangeCover(images[0].src)
    }

    return (

        <div className={`card d-flex justify-content-center align-items-center border-16 mb-3 ${props.errors.coverImageUrl ? 'input-error' : ''}`}>
            <div className="title-18 hero-title mt-4">
                <i className="fa-solid fa-circle-exclamation marg-right-10" style={{ color: '#eb4799'}}></i> Select the best photo
            </div>
            <div className=" d-flex justify-content-center align-items-center  padd-20" >
                <UploadImages errors={false} OnUploadImages={UploadImagesHandler} image={props.property.heroSection?.coverImageUrl} listImages={props.property.listingImages || []} multipleImgs={false} height={"height-400"} label={"Upload Photo"} />
            </div>
        </div>

    )
}

export default CoverPhoto;